"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _ref13;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.SliderFooterSecondaryNav = exports.SliderFooterPrimaryNav = exports.SliderFooterNavItem = exports.SliderNavColumn = exports.SliderFooterNavWrap = exports.SliderFooter = exports.SliderNavWrap = exports.SliderAction = exports.ActionsWrap = exports.SliderBurgerWrap = exports.LogoWrap = exports.SliderHeaderWrap = exports.SliderHeader = exports.MenuSliderWrap = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _Layout = require("../../Layout");

var _MegaMenu = require("../MenuVariants/MegaMenu/MegaMenu.style");

var _Button = _interopRequireDefault(require("../../Button"));

var _Link = _interopRequireDefault(require("../../Link"));

var _mediaQueries = _interopRequireDefault(require("../../../styles/mediaQueries"));

var _UtilityNav = require("../UtilityNav/UtilityNav.style");

var MenuSliderWrap = (0, _styled.default)('div')(function (_ref) {
  var isNavOpen = _ref.isNavOpen,
      isSecondarySliderOpen = _ref.isSecondarySliderOpen;
  return {
    display: 'block',
    position: 'fixed',
    top: '0',
    bottom: '0',
    right: '0',
    left: '0',
    zIndex: '101',
    overflowX: 'hidden',
    overflowY: isSecondarySliderOpen ? 'hidden' : 'auto',
    opacity: isNavOpen ? '1' : '0',
    transition: isNavOpen ? 'transform 1.5s ease' : 'all .5s ease-in-out',
    transform: isNavOpen ? 'translateX(0)' : 'translateX(100%)'
  };
}, function (_ref2) {
  var _ref2$theme = _ref2.theme,
      colors = _ref2$theme.colors,
      globalNav = _ref2$theme.globalNav;
  return (0, _styledSystem.variant)({
    prop: 'variation',
    variants: {
      mega: {
        color: colors[globalNav.megaSliderColor],
        backgroundColor: colors[globalNav.megaSliderMainBg]
      },
      primary: {
        top: _UtilityNav.utilityNavHeight,
        color: colors[globalNav.primaryMenuSliderColor],
        backgroundColor: colors[globalNav.primaryMenuSliderMainBg]
      }
    }
  });
});
exports.MenuSliderWrap = MenuSliderWrap;
var SliderHeader = (0, _styled.default)('div')(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      globalNav = _ref3$theme.globalNav;
  return (0, _styledSystem.variant)({
    prop: 'variation',
    variants: {
      mega: {
        backgroundColor: colors[globalNav.megaSliderHeaderBg],
        borderBottom: "".concat(globalNav.megaSliderHeaderBorder, " ").concat(globalNav.megaSliderHeaderBorderColor)
      },
      primary: {
        backgroundColor: colors[globalNav.primaryMenusliderHeaderBg],
        borderBottom: "".concat(globalNav.primaryMenuSliderHeaderBorder, " ").concat(colors[globalNav.primaryMenuSliderHeaderBorderColor])
      }
    }
  });
});
exports.SliderHeader = SliderHeader;
var SliderHeaderWrap = (0, _styled.default)(_Layout.Container)({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  minHeight: _MegaMenu.headerHeight,
  '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
    height: '0'
  }
});
exports.SliderHeaderWrap = SliderHeaderWrap;
var LogoWrap = (0, _styled.default)('div')({
  display: 'block'
});
exports.LogoWrap = LogoWrap;
var SliderBurgerWrap = (0, _styled.default)('div')(function (_ref4) {
  var isNavOpen = _ref4.isNavOpen;
  return {
    opacity: isNavOpen ? '1' : '0',
    transition: 'color .3s linear'
  };
}, function (_ref5) {
  var _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      globalNav = _ref5$theme.globalNav;
  return (0, _styledSystem.variant)({
    prop: 'variation',
    variants: {
      mega: {
        color: colors[globalNav.megaBurgerActiveColor],
        '&:hover': {
          color: colors[globalNav.megaBurgerActiveColorHover]
        }
      },
      primary: {
        color: colors[globalNav.primaryMenuBurgerActiveColor],
        '&:hover': {
          color: colors[globalNav.primaryMenuBurgerActiveColorHover]
        }
      }
    }
  });
});
exports.SliderBurgerWrap = SliderBurgerWrap;
var ActionsWrap = (0, _styled.default)('div')(function (_ref6) {
  var _ref7;

  var _ref6$theme = _ref6.theme,
      space = _ref6$theme.space,
      globalNav = _ref6$theme.globalNav,
      actions = _ref6.actions;
  return _ref7 = {
    paddingTop: space.medium,
    paddingBottom: space.xsmall,
    borderBottom: actions ? globalNav.actionsWrapBorder : '0',
    display: 'block',
    overflowX: 'hidden'
  }, _defineProperty(_ref7, _mediaQueries.default.medium, {
    display: 'flex',
    alignItems: 'center'
  }), _defineProperty(_ref7, '>a', _defineProperty({
    display: 'block',
    marginRight: '0',
    marginBottom: space.small
  }, _mediaQueries.default.medium, {
    display: 'inline-block',
    marginRight: space.medium
  })), _ref7;
});
exports.ActionsWrap = ActionsWrap;
var SliderAction = (0, _styled.default)(_Button.default)(function (_ref8) {
  var _ref9;

  var _ref8$theme = _ref8.theme,
      space = _ref8$theme.space,
      globalNav = _ref8$theme.globalNav;
  return _ref9 = {
    fontSize: globalNav.sliderActionFontSizeMobile,
    minWidth: '100%',
    maxWidth: '100%',
    marginBottom: space.medium
  }, _defineProperty(_ref9, _mediaQueries.default.small, {
    fontSize: globalNav.sliderActionFontSizeDesktop,
    width: '100%',
    marginBottom: '0'
  }), _defineProperty(_ref9, _mediaQueries.default.medium, {
    minWidth: 'initial',
    marginBottom: '0'
  }), _defineProperty(_ref9, '>span', {
    overflow: 'hidden',
    '&:first-of-type': {
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        marginTop: globalNav.buttonTextMarginIE
      }
    }
  }), _ref9;
});
exports.SliderAction = SliderAction;
var SliderNavWrap = (0, _styled.default)('div')(function (_ref10) {
  var space = _ref10.theme.space;
  return _defineProperty({
    display: 'block',
    marginTop: space.large,
    marginBottom: space.large
  }, _mediaQueries.default.medium, {
    display: 'block'
  });
});
exports.SliderNavWrap = SliderNavWrap;
var SliderFooter = (0, _styled.default)('div')(function (_ref12) {
  var space = _ref12.theme.space;
  return {
    marginTop: space.xxlarge,
    marginBottom: space.large
  };
});
exports.SliderFooter = SliderFooter;
var SliderFooterNavWrap = (0, _styled.default)('div')((_ref13 = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start'
}, _defineProperty(_ref13, _mediaQueries.default.medium, {
  alignItems: 'center',
  justifyContent: 'space-between'
}), _defineProperty(_ref13, '>div', _defineProperty({
  flexBasis: '50%'
}, _mediaQueries.default.medium, {
  flexBasis: 'auto'
})), _ref13));
exports.SliderFooterNavWrap = SliderFooterNavWrap;
var SliderNavColumn = (0, _styled.default)(_Layout.Column)(function (_ref14) {
  var space = _ref14.theme.space;
  return _defineProperty({
    marginBottom: '0'
  }, _mediaQueries.default.medium, {
    marginBottom: space.xlarge
  });
});
exports.SliderNavColumn = SliderNavColumn;
var SliderFooterNavItem = (0, _styled.default)(_Link.default)(function (_ref16) {
  var _ref17;

  var _ref16$theme = _ref16.theme,
      globalNav = _ref16$theme.globalNav,
      colors = _ref16$theme.colors,
      space = _ref16$theme.space;
  return _ref17 = {
    width: '100%',
    marginBottom: space.medium
  }, _defineProperty(_ref17, _mediaQueries.default.small, {
    width: 'auto'
  }), _defineProperty(_ref17, "span", {
    color: colors[globalNav.sliderFooterLinkColor],
    borderColor: colors.none
  }), _defineProperty(_ref17, '&:hover span', {
    borderColor: "".concat(colors[globalNav.sliderFooterLinkColor], " !important")
  }), _ref17;
});
exports.SliderFooterNavItem = SliderFooterNavItem;
var SliderFooterPrimaryNav = (0, _styled.default)('div')(function (_ref18) {
  var space = _ref18.theme.space;
  return {
    '>a': _defineProperty({
      marginRight: space.medium,
      display: 'block'
    }, _mediaQueries.default.medium, {
      display: 'inline-block',
      marginRight: space.xxlarge
    })
  };
});
exports.SliderFooterPrimaryNav = SliderFooterPrimaryNav;
var SliderFooterSecondaryNav = (0, _styled.default)('div')(function (_ref19) {
  var space = _ref19.theme.space;
  return {
    '>a': _defineProperty({
      marginLeft: space.medium,
      display: 'block'
    }, _mediaQueries.default.medium, {
      display: 'inline-block',
      marginLeft: space.xxlarge
    })
  };
});
exports.SliderFooterSecondaryNav = SliderFooterSecondaryNav;